module.exports = __webpack_public_path__ + "img/progress-rounded-dark.87c0eb23.svg";